/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Bwf_Reference_Time_LabelInputs */

const en_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reference Time`)
};

const fr_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de référence`)
};

const de_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referenzzeit`)
};

const it_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di riferimento`)
};

const ru_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Референтное время`)
};

const es_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de referencia`)
};

const zh_cn2_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`参考时间`)
};

const ja_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基準時間`)
};

const hi_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संदर्भ समय`)
};

const pt_pt2_audio_description_export_bwf_reference_time_label = /** @type {(inputs: Audio_Description_Export_Bwf_Reference_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de referência`)
};

/**
* | output |
* | --- |
* | "Reference Time" |
*
* @param {Audio_Description_Export_Bwf_Reference_Time_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_bwf_reference_time_label = /** @type {((inputs?: Audio_Description_Export_Bwf_Reference_Time_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Bwf_Reference_Time_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "de") return de_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "it") return it_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "ru") return ru_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "es") return es_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "ja") return ja_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "hi") return hi_audio_description_export_bwf_reference_time_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_bwf_reference_time_label(inputs)
	return en_audio_description_export_bwf_reference_time_label(inputs)
});